import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface SEOText {
  id: string;
  section_key: string;
  title: string;
  content: string;
}

const SEOTextSection = () => {
  const { data: texts = [] } = useQuery({
    queryKey: ["landing_seo_texts_public"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("landing_seo_texts")
        .select("*")
        .eq("is_active", true)
        .order("sort_order");
      if (error) throw error;
      return data as SEOText[];
    },
    staleTime: 5 * 60 * 1000,
  });

  if (texts.length === 0) return null;

  return (
    <section className="py-12 relative" id="about">
      <div className="container px-4 mx-auto">
        <div className="max-w-3xl mx-auto space-y-6">
          {texts.map((block, index) => (
            <div key={block.id}>
              <h2 className={`font-display ${index === 0 ? 'text-xl sm:text-2xl' : 'text-base'} font-bold mb-3 text-foreground`}>
                {block.title}
              </h2>
              {block.content.split("\n\n").map((paragraph, pi) => (
                <p key={pi} className="text-muted-foreground leading-relaxed text-sm mb-2">
                  {paragraph}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SEOTextSection;
